import React from "react";
import { AgentStatusProvider } from "./AgentStatusContext.jsx";

const AppProviders = ({ children }) => {
    return (
        <AgentStatusProvider>
            {children}
        </AgentStatusProvider>
    );
};

export default AppProviders;
